import * as React from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import { uploadFile } from "../../api/files";
import Lato from "../../assets/Lato-Bold.ttf";
import pdfHeard from "../../assets/header.png";
import pdfFirma from "../../assets/firma.png";
import { BlobProvider, Document, Page, Text, View, Font, StyleSheet, Image } from "@react-pdf/renderer";
import { Button } from "reactstrap";
import SignatureCanvas from "react-signature-canvas";
import moment from "moment";
import { Row, Col, Spinner, Alert } from "reactstrap";
import PageLayout from "../../components/PageLayout";
import Loading from "../../components/Loading";
import { getCollaudo, signCollaudo } from "../../api/collaudo";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getUser } from "../../api/users";

Font.register({
    family: "Lato Bold", src: Lato
});
//console.log(Lato);

Font.registerHyphenationCallback(word => [word]);

let sign;
// Create styles
const styles = StyleSheet.create({
    page: {
        padding: "20px",
        color: "#000"
    },
    formField: {
        fontSize: "10pt",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        marginTop: "2px"
    },
    fieldLabel: {
        fontFamily: "Lato Bold",
        color: "#9D9D9D",

        flexDirection: "row",
        marginRight: "15px",
        alignItems: "center"
    },
    fieldValue: {
        fontFamily: "Lato Bold",
        flexDirection: "row",
        alignItems: "center",
        color: "#000000",
        borderBottom: "1pt",
        flex: 1,
        marginRight: "15px",
        minHeight: "9pt"
        //textAlign: 'center'
        // width: '100%'
    },
    section: {
        width: "100%",
        marginTop: "12px",
        padding: "10px",
        border: "1pt"
    },

    disclaimer: {
        fontSize: "7pt",
        marginTop: "5px"
    },
    contractDetails: {
        fontSize: "7pt",
        marginBottom: "10px"
    },
    headings: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },

    leftSignature: {
        borderRight: "1pt",
        flex: 1,
        marginRight: "5px",
        textAlign: "center",
    },
    rightSignature: {
        flex: 1
    }
});

export default function PdfReport() {
    const [signature, setSignature] = React.useState();
    const { collaudoId } = useParams();
    const { geo } = useAuth0();
    const [loading, setLoading] = React.useState(true);
    const [collaudo, setCollaudo] = React.useState();
    const [service, setService] = React.useState();
    const { push } = useHistory();
    const [dataCollaudo, setDataCollaudo] = React.useState();

    React.useEffect(() => {
        loadCollaudo();
    }, []);

    React.useEffect(() => {
        loadService();
    }, []);

    async function onSignCollaudo(blob) {
        try {
            setLoading(true);
            const doc = await uploadFile(
                `certificatocollaudo-${collaudo._id}.pdf`,
                blob
            );
            await signCollaudo(collaudo._id, doc, dataCollaudo);
            push("/collaudo/list");
        } finally {
            setLoading(false);
        }
    }

    async function loadCollaudo() {
        try {
            setLoading(true);
            const collaudoRes = await getCollaudo(collaudoId);
            setCollaudo(collaudoRes);
        } finally {
            setLoading(false);
        }
    }

    async function loadService() {
        try {
            setLoading(true);
            const activeUser = localStorage.getItem("activeUser");
            const serviceRes = await getUser(activeUser);
            setService(serviceRes);
        } finally {
            setLoading(false);
        }
    }

    function signModule() {
        if (!sign.isEmpty()) {
            const image = sign.toDataURL();
            setSignature(image);
            const data = prompt("Confermare la data del collaudo", moment().format("DD/MM/YYYY"));
            setDataCollaudo(data);
        }
    }

    async function uploadPdf(blob) {
        // setProgress(0);
        // const file = await entityService.upload(
        //     blob,
        //     `esito-collaudo-${collaudoId || ""}.pdf`,
        //     (prog, total) => {
        //         const progress = (prog * 100) / total;
        //         setProgress(Math.round(progress));
        //     }
        // );
        // await onCollaudoEnd(file, collaudoId);
    }

    const CollaudoPDF = () => {
        const customer = {
            name: collaudo.customer_name,
            ticket: collaudo.customer_ticket,
            address: collaudo.customer_address,
            reference: collaudo.customer_attributes.reference1,
            email: collaudo.customer_email,
            phone: collaudo.customer_attributes.phone,
            taxcode: collaudo.customer_taxcode
        };
        const vehicle = {
            plate: collaudo.plate,
            ...collaudo.vehattrib,
            registrationDate: collaudo.meta.vehicle.registeredat
        };
        const device = {
            imei: collaudo.imei,
            sn: collaudo.serial,
            tel: collaudo.number
        };
        const installatore = {
            name: service.surname + " " + service.name,
            address: service.address,
            phone: service.phone,
            email: service.email
        };
        const order = collaudo.order
            ? {
                deliveryDate: collaudo.order.attributes.delivery_date,
                code: collaudo.order._id,
                creationdate: collaudo.order.order_date,
                reference: collaudo.order.order_ref
            }
            : {};
        const position = collaudo.meta.tests.find(
            el => el.id === "test-posizione" && el.value.completed
        );

        const quadro = collaudo.meta.tests.find(
            el => el.id === "test-quadro-on" && el.value.skipped
        ) ? "OK" : "OK";

        const can = collaudo.meta.tests.find(
            el => el.id === "test-can" && el.value.skipped
        ) ? "OK" : "NO";

        const blocco = collaudo.meta.tests.find(
            el => el.id === "test-blocco-1" && el.value.skipped
        ) ? "OK" : "OK";

        const sats = position && position.value.position.attributes.sat;
        const sale = collaudo.meta.sale;
        const address = position && position.value.address;

        return (
            <Document
                author="Piramis Locator"
                keywords="esito collaudo"
                title="Esito collaudo"
            >
                <Page size="A4" style={styles.page}>
                    <View style={styles.headings}>
                        <Image src={pdfHeard} style={{ width: "200pt", display: "flex" }} />
                        <Text
                            style={{ fontSize: 13, display: "flex", fontFamily: "Lato Bold" }}
                        >
                            CERTIFICATO  DI  INSTALLAZIONE  E  COLLAUDO
                        </Text>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>
                                Ragione Sociale / Cognome - Nome
                            </Text>
                            <Text style={styles.fieldValue}>{customer.name}</Text>
                        </View>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Indirizzo</Text>
                            <Text style={styles.fieldValue}>
                                {`${customer.address.street} - ${customer.address.cap} ${geo.getComuneLabel(
                                    customer.address.city
                                )} (${customer.address.province.toUpperCase()})`}
                            </Text>
                        </View>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Telefono</Text>
                            <Text style={styles.fieldValue}>{customer.phone || " "}</Text>
                            <Text style={styles.fieldLabel}>email</Text>
                            <Text style={styles.fieldValue}>{customer.email || ""}</Text>
                        </View>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>C.F. / Piva</Text>
                            <Text style={styles.fieldValue}>{customer.taxcode}</Text>
                            <Text style={styles.fieldLabel}>Riferimento</Text>
                            <Text style={styles.fieldValue}>{customer.reference}</Text>
                        </View>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Prodotto</Text>
                            <Text style={styles.fieldValue}>{sale ? sale.meta.product.description : ""}</Text>
                        </View>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>IMEI</Text>
                            <Text style={styles.fieldValue}>{device.imei || " "}</Text>
                            <Text style={styles.fieldLabel}>Seriale</Text>
                            <Text style={styles.fieldValue}>{device.sn || ""}</Text>
                            <Text style={styles.fieldLabel}>Telefono</Text>
                            <Text style={styles.fieldValue}>{device.tel || ""}</Text>
                        </View>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Numero Ordine</Text>
                            <Text style={styles.fieldValue}>{order.code}</Text>
                        </View>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Rif Ordine</Text>
                            <Text style={styles.fieldValue}>{order.reference}</Text>
                        </View>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Del</Text>
                            <Text style={styles.fieldValue}>
                                {dataCollaudo}
                            </Text>
                            <Text style={styles.fieldLabel}>Consegnato il</Text>
                            <Text style={styles.fieldValue}>
                                {moment(order.deliveryDate).format("DD/MM/YYYY")}
                            </Text>
                        </View>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Marca e Modello</Text>
                            <Text
                                style={styles.fieldValue}
                            >{`${vehicle.make} ${vehicle.model} ${vehicle.preparation}`}</Text>
                        </View>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Telaio</Text>
                            <Text style={styles.fieldValue}>{vehicle.frame || " "}</Text>
                            <Text style={styles.fieldLabel}>Targa</Text>
                            <Text style={styles.fieldValue}>{vehicle.plate || ""}</Text>
                            <Text style={styles.fieldLabel}>Immatricolazione</Text>
                            <Text style={styles.fieldValue}>
                                {vehicle.registrationDate
                                    ? moment(vehicle.registrationDate).format("DD/MM/YYYY")
                                    : ""}
                            </Text>
                        </View>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Cod. Collaudo</Text>
                            <Text style={styles.fieldValue}>{collaudoId}</Text>
                            <Text style={styles.fieldLabel}>Data</Text>
                            <Text style={styles.fieldValue}>{dataCollaudo}</Text>
                        </View>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Cod. Centrale Operativa</Text>
                            <Text style={styles.fieldValue}>{customer.ticket || " "}</Text>
                        </View>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Indirizzo rilevato</Text>
                            <Text style={styles.fieldValue}>{address}</Text>
                        </View>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Satelliti rilevati</Text>
                            <Text style={styles.fieldValue}>{sats}</Text>
                            <Text style={styles.fieldLabel}>Test Quadro</Text>
                            <Text style={styles.fieldValue}>{quadro}</Text>
                            <Text style={styles.fieldLabel}>Test linea CAN</Text>
                            <Text style={styles.fieldValue}>{can}</Text>
                            <Text style={styles.fieldLabel}>Test Blocco Avviamento</Text>
                            <Text style={styles.fieldValue}>{blocco}</Text>
                        </View>
                    </View>

                    <View style={[styles.section, { padding: 0, flexDirection: "row" }]}>
                        <View style={styles.leftSignature}>
                            <Text style={{ fontSize: "6pt", fontFamily: "Lato Bold" }}>
                                {`Timbro e firma dell'installatore`}
                            </Text>
                            <Image src={signature} style={{ marginTop: "10px" }} />
                            <Text style={{ minHeight: "10px" }}>{""}</Text>
                            <Text style={{ fontSize: "6pt" }}>
                                {`Si dichiara di aver eseguito l'installazione a regola d'arte ed aver collaudato il dispositivo ed i suoi componenti nel rispetto delle norme vigenti in materia di sicurezza.`}
                            </Text>
                        </View>
                        <View style={styles.rightSignature}>
                            <Text
                                style={{
                                    fontSize: "6pt",
                                    fontFamily: "Lato Bold",
                                    textAlign: "center"
                                }}
                            >
                                {`Installatore`}
                            </Text>
                            <View style={styles.formField}>
                                <Text style={styles.fieldLabel}>Rag. Sociale</Text>
                                <Text style={styles.fieldValue}>{installatore.name}</Text>
                            </View>
                            <View style={styles.formField}>
                                <Text style={styles.fieldLabel}>Indirizzo</Text>
                                <Text style={styles.fieldValue}>
                                    {`${installatore.address.street}-${geo.getComuneLabel(installatore.address.city)} (${installatore.address.province.toUpperCase()})`}
                                </Text>
                            </View>
                            <View style={styles.formField}>
                                <Text style={styles.fieldLabel}>Tel.</Text>
                                <Text style={styles.fieldValue}>{installatore.phone}</Text>
                            </View>
                            <View style={[styles.formField, { marginBottom: "3px" }]}>
                                <Text style={styles.fieldLabel}>email</Text>
                                <Text style={styles.fieldValue}>{installatore.email}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.section}>
                        <View style={styles.formField}>
                            <Text style={styles.fieldLabel}>Data inizio contratto</Text>
                            <Text style={[styles.fieldValue, { flex: 1 }]}>
                                {dataCollaudo}
                            </Text>
                            <Text style={styles.fieldLabel}>
                                Mesi sottoscritti alla firma
                            </Text>
                            <Text
                                style={[styles.fieldValue, { flex: 0.5, textAlign: "center" }]}
                            >
                                {sale ? sale.meta.product.duration : ""}
                            </Text>
                            <Text style={styles.fieldLabel}>Data prossimo rinnovo</Text>
                            <Text style={[styles.fieldValue, { flex: 1 }]}>
                                {moment(dataCollaudo, "DD/MM/YYYY")
                                    .add(Number(sale ? sale.meta.product.duration : 0), "months")
                                    .format("DD/MM/YYYY")}
                            </Text>
                        </View>
                    </View>
                    <View style={styles.disclaimer}>
                        <Text>
                            {`Il cliente dichiara di approvare ed accettare espressamente, anche ai sensi degli art. 1341 e ss. c.c., le condizioni generali del "contratto di utilizzo servizi Piramis", con
particolare riferimento alle clausole specificate sul retro del presente modulo, prendendo atto che le stesse in ogni caso risultano integralmente riportate e visibili sul
sito www.piramisgroup.com e che dalla data di decorrenza indicata il predetto contratto dovrà considerarsi valido ed efficace a tutti gli effetti di legge. Dichiaro di aver ricevuto
l'informativa orale di cui all'art.13 D.lgs n.196/2003, in materia di privacy come specificata al p.to 5 della condizioni generali in calce al presente modulo, e di acconsentire al
trattamento dei miei dati personali, anche sensibili, autorizzando a tal fine Piramis srl, nei limiti e per le finaltà inerenti il contratto in essere.`}
                        </Text>
                    </View>
                    <View
                        style={[
                            styles.section,
                            {
                                padding: 0,
                                flexDirection: "row",
                                border: 0,
                                justifyContent: "space-between"
                            }
                        ]}
                    >
                        <View
                            style={[styles.leftSignature, { border: "1pt", padding: "5px" }]}
                        >
                            <Text style={{ fontSize: "6pt", fontFamily: "Lato Bold" }}>
                                {`Firma del Titolare`}
                            </Text>
                            <Text style={{ minHeight: "30px" }}>{""}</Text>
                            <Text style={{ fontSize: "6pt", marginTop: "50px" }}>
                                {`Si prende atto del corretto funzionamento dell’apparato e dei servizi e si dichiara di aver ricevuto copia di tutta la documentazione incluso il presente certificato di collaudo.`}
                            </Text>
                        </View>
                        <View
                            style={[styles.rightSignature, { border: "1pt", padding: "5px" }]}
                        >
                            <Text
                                style={{
                                    fontSize: "6pt",
                                    fontFamily: "Lato Bold",
                                    textAlign: "center"
                                }}
                                break
                            >
                                {`Firma Piramis srl`}
                            </Text>
                            <Image src={pdfFirma} style={{ width: "180pt", display: "flex", marginTop: "5px", marginLeft: "50px", textAlign: "center" }} />
                        </View>
                    </View>
                </Page>
                <Page size="A4" style={styles.page}>
                    <Text style={styles.contractDetails}>
                        {`La società Piramis srl, quale società di servizi dedicata allo sviluppo di progetti telematici, si occupa, tra le altre, della fornitura e gestione di un servizio telematico per la cui
fruizione è utilizzato uno strumento Web chiamato “piattaforma” + APP per piattaforme Android e iOS. Per la raccolta dei dati necessari alla fruizione del servizio stesso,
Piramis srl si avvale dell’utilizzo di un dispositivo di geolocalizzazione satellitare anche di terze parti, di seguito denominato “dispositivo”.
Le premesse, così come gli allegati e le appendici formano parte integrante del presente contratto.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`1. Con il presente contratto, la società Piramis srl fornisce il servizio di cui in premessa, il dispositivo a corredo deve essere installato sul veicolo del cliente presso un centro
autorizzato, con spese a carico del cliente stesso.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`2. L’installatore convenzionato risponderà direttamente nei confronti del cliente della corretta ed a regola d’arte installazione nonché di tutte le eventuali operazioni di manutenzione effettuate e dei danni derivanti da tali operazioni.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`2.1. L’installazione del dispositivo comporterà, in favore del cliente, l’utilizzo ed il godimento di tutti i servizi telematici ad esso connessi ed in specie un abbonamento che
prevede l’utilizzo della piattaforma dedicata, mediante registrazione, nonché la possibilità di scaricare ed utilizzare le App dedicate iOS e Android, ivi compresa l’assistenza
attraverso il numero verde dedicato (800192774) e tutti gli aggiornamenti necessari al buon funzionamento del sistema.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`3. Il cliente si impegna ad adibire il dispositivo al veicolo indicato nella procedura di registrazione e a non installarlo su altri veicoli, se non previo avviso alla Società da
effettuarsi secondo la procedura indicata nel Sito (www.piramisgroup.com) nonché ad assicurarsi che i dati richiesti per la registrazione ed indicati nell’account personale siano corretti
ed aggiornati per tutta la durata dell’abbonamento.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`
3.1. Il cliente si impegna altresì a mantenere in buono stato il dispositivo installato e ad utilizzarlo solo per scopi connessi alla fruizione dei servizi offerti dalla società Piramis
srl e regolati nel presente contratto, senza manometterlo nemmeno in caso di malfunzionamento. La scheda telefonica abbinata al dispositivo è parte integrante dello stesso
e di proprietà di Piramis e non va rimossa in nessun caso.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`3.2. Nel caso di violazione di una o più delle garanzie previste al punto 3 che precede, Piramis srl potrà sospendere l’erogazione dei Servizi sino a quando il Cliente non avrà
adempiuto. La sospensione dei servizi non sospenderà l’abbonamento.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`3.3. Non è previsto il tacito rinnovo dell’abbonamento; pertanto, in prossimità della scadenza triennale, al cliente perverrà un avviso ai fini del rinnovo e, in mancanza di
pagamento del canone pattuito, il dispositivo come la SIM contenuta all’interno dello stesso, verranno disabilitati e sarà cura del Cliente decidere se procedere o meno alla
disinstallazione del dispositivo.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`4. Nelle ipotesi di inosservanza, inadempimento e/o inesatto adempimento delle obbligazioni previste ai p.ti 2 e 3, il contratto dovrà intendersi risolto di diritto, ai sensi e per gli
effetti dell'art.1456 c.c., allorquando la parte che ha interesse ne dà comunicazione all'altra, Piramis srl potrà trattenere gli importi ricevuti dal cliente per le prestazioni già
eseguite, salvo il diritto al risarcimento del danno.`}
                    </Text>
                    <Text style={styles.contractDetails}>{`5. Privacy:`}</Text>
                    <Text style={styles.contractDetails}>
                        {`5.1. Piramis srl garantisce che il trattamento dei dati personali si svolga nel pieno rispetto dei diritti, delle libertà fondamentali e della dignità delle persone fisiche, con
particolare riferimento alla riservatezza ed all'identità personale, impedendo l'accesso alle informazioni da parte di terzi non autorizzati.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`5.2. I dati personali oggetto del trattamento da parte di Piramis srl saranno custoditi e controllati in modo da ridurre al minimo i rischi di distruzione o perdita anche
accidentale dei dati stessi, di accesso non consentito o non conforme alla finalità della raccolta.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`5.3. Piramis srl si impegna a rispettare le disposizioni contenute nel Decreto Legislativo del 30 giugno 2003 n. 196 e nel Regolamento Europeo GDPR n. 679/16`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`5.4. Piramis srl si impegna a non comunicare, diffondere o trasferire a terzi i dati personali del Cliente. Piramis srl si impegna inoltre a non utilizzare le informazioni
trasmesse dal Dispositivo per finalità diverse da quelle necessarie all'erogazione dei Servizi. Piramis srl garantisce altresì il rispetto degli obblighi di cui al presente paragrafo
anche da parte dei propri dipendenti o collaboratori autonomi.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`5.5. Il Cliente prende atto che la fornitura dei Servizi relativi ai dati rilevati dal Dispositivo installato sul suo Veicolo comporta che Piramis srl acquisisca tutti i dati rilevati da
tale Dispositivo.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`5.6. Con la stipula del presente Contratto il Cliente quindi autorizza e delega Piramis srl all'acquisizione dei dati suddetti nonché alla loro memorizzazione in banche dati
Piramis srl ed alla loro conservazione fino alla scadenza del servizio.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`6. All'atto dell'attivazione dell'abbonamento e del servizio che costituiscono oggetto del presente contratto, al Cliente viene consegnata una tessera contenente i codici
necessari alla registrazione e attivazione delle piattaforme; mentre al momento della creazione di un account sul sito viene richiesta una password per proteggere le
informazioni relative allo stesso. Il Cliente è responsabile del mantenimento della riservatezza dei suddetti codici, username e password. Il possesso e la conoscenza degli
stessi da parte di terze persone, in assenza di specifica comunicazione di denuncia in merito a smarrimenti e/o furti, legittima Piramis srl a rilasciare informazioni in merito al
servizio oggetto del presente contratto, la quale in tali casi sarà autorizzata in tal senso e liberata da ogni responsabilità anche per le finalità di informazioni fornite alle forze
dell’ordine`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`6.1. Divulgazioni e trasferimenti informazioni:`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`6.2. Piramis srl si impegna a non divulgare le informazioni ed i dati personali degli utenti a terzi, salve le seguenti eccezioni:
a) utilizzo del servizio per attività illegali e/o coinvolgimento del Cliente in attività illegali; b) richiesta da parte di autorità statali, giudiziarie, di polizia, di vigilanza, forze
dell'Ordine e similari, anche in assenza di uno specifico ordine o mandato giudiziario e in ogni caso in cui si dovesse rendere necessaria la divulgazione, nel rispetto delle
leggi, in collaborazione con le suddette autorità, nei confronti di utenti che dovessero risultare impegnati o coinvolti in attività illegali; c) comunicazione e/o possesso dei codici
contenuti nella tessera di cui al p.to precedente.`}
                    </Text>
                    <Text style={styles.contractDetails}>
                        {`6.3. Piramis srl si riserva il diritto di segnalare alle Forze dell'Ordine eventuali attività considerate illegali ed in violazione di disposizioni di legge.8.
7. Per ogni controversia che dovesse insorgere relativamente all’interpretazione ed esecuzione del presente contratto si osserverà la competenza del Foro di residenza del
Cliente/Consumatore.`}
                    </Text>
                </Page>
            </Document>
        );
    };

    if (loading) return <Loading />;

    if (collaudo && collaudo.status === "firmato") {
        return (
            <PageLayout
                title="Collaudo Firmato"
                optionalNav={{ link: "/collaudo/list", text: "Elenco Collaudi" }}
            >
                <Row>
                    <Col xs="12">
                        Il collaudo è stato correttamente firmato.
                    </Col>
                    <Col xs="12">
                        <Button
                            className="mr-2 mt-2"
                            color="warning"
                            onClick={() => {
                                history.go(-1);
                            }}
                        >
                            <FontAwesomeIcon icon="reply" /> Torna
                        </Button>
                        <Button className="mt-2"
                            onClick={() => {
                                push(`/collaudo/docs/${collaudo._id}`);
                            }}
                            color="primary"
                        >
                            <FontAwesomeIcon icon="file-pdf" /> Visualizza documento di collaudo
                        </Button>
                    </Col>
                </Row>
            </PageLayout>
        );
    }

    return (
        <PageLayout
            title="Firma e carica il certificato di collaudo"
            optionalNav={{ link: "/collaudo/list", text: "Elenco Collaudi" }}
        >
            {!signature && (
                <Row>
                    <Col xs="12">
                        <strong>Firma e registra collaudo</strong>
                        <SignatureCanvas
                            penColor="black"
                            backgroundColor="#fff"
                            canvasProps={{
                                className: "sigCanvas"
                            }}
                            ref={ref => {
                                if (ref) {
                                    sign = ref;
                                }
                            }}
                        />
                    </Col>
                    <Col xs="12">
                        <div className="float-right mt-5">
                            <Button
                                onClick={() => sign.clear()}
                                color="secondary"
                            >
                                <FontAwesomeIcon icon="eraser" /> Pulisci
                            </Button>
                            <Button className="ml-2"
                                onClick={signModule}
                                color="success"
                            >
                                <FontAwesomeIcon icon="signature" /> Conferma
                            </Button>
                        </div>
                    </Col>
                </Row>
            )}
            {signature && (
                <Row>
                    <Col>
                        <BlobProvider document={<CollaudoPDF />}>
                            {({ blob, url, loading, error }) => {
                                if (error) {
                                    return (
                                        <Alert color="danger" title="Errore!">
                                            <p>
                                                {" "}
                                                Errore durante la generazione del documento di collaudo.
                                                Si prega di ricaricare la pagina. Se il problema
                                                persiste contattare il supporto tecnico.
                                            </p>
                                        </Alert>
                                    );
                                }
                                return (
                                    <Row>
                                        <Col>
                                            {loading && !url ? (
                                                <span>
                                                    <Spinner /> Creazione pdf del collaudo in corso...
                                                </span>
                                            ) : (
                                                    <div>

                                                        <Button className="mr-2"
                                                            onClick={() => {
                                                                window.open(url, "_blank");
                                                            }}
                                                            color="primary"
                                                        >
                                                            <FontAwesomeIcon icon="file-pdf" /> Visualizza documento di collaudo
                                                        </Button>
                                                        <Button
                                                            onClick={() => {
                                                                onSignCollaudo(blob);
                                                            }}
                                                            color="success"
                                                        >
                                                            <FontAwesomeIcon icon="clipboard-check" /> Chiudi il collaudo
                                                        </Button>
                                                    </div>
                                                )}
                                        </Col>
                                    </Row>
                                );
                            }}
                        </BlobProvider>
                    </Col>
                </Row>
            )}
        </PageLayout>
    );
}
